<template>
    <div class="invoice">
        <div class="container order-content">
            <div class="manage-main">
                <div class="rule" style="overflow: hidden">
                    <Menu></Menu>
                    <div class="manage-right">
                        <div class="right-title">充值记录</div>
                        <div class="manage-invoice-hotel">
                        	<div class="time">
                                <span class="input-label">日期选择：</span>
                                <input type="text" class="date-time" v-model="Start" @click="calendar.show=true" data-type="time" readonly>
                                 -
                                <input type="text" class="date-time" v-model="End" @click="calendar.show=true" data-type="time" readonly>
                                <DatePicker @select="calendar.select" v-show="calendar.show" :start="calendar.start"
                                            :beginDate="calendar.begin" :last="calendar.last" :endDate="calendar.end" >
                                </DatePicker>
                                <span class="timeExcel" @click="export2Excel">导出</span>
                                <span class="timeSearch" @click="getChargeData(true)">搜索</span>
                                
                            </div>
                        </div>
                        <div class="invoice-table-box">
                            <table class="invoice-table">
                                <thead>
                                <tr>
                                    <td width="25%">货币类型</td>
                                    <td width="25%">充值额度</td>
                                    <td width="25%">已使用额度</td>
                                    <td width="25%">充值时间</td>
                                    
                                </tr>
                                </thead>
                                <tbody v-if="!isLoading && ChargeList.length > 0">
                                <tr v-for="item in ChargeList">
                                    <td width="25%">{{item.Currency}}</td>
                                    <td width="25%">{{item.ArriveNum}}</td>
                                    <td width="25%">{{item.UsedNum}}</td>
                                    <td width="25%">{{item.ArriveDate|dateClock}}</td>
                                    
                                   
                                </tr>
                                </tbody>
                                <tbody v-else>
                                <tr>
                                    <td align="center" style="vertical-align: middle" colspan="9">
                                        <div v-if="isLoading">
                                            <Loading :isLoading="isLoading"></Loading>
                                        </div>
                                        <div v-else>{{noneDataMsg}}</div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                           <div class="Page">
                                <span @click="handlePrev" class="PageBtn">上一页</span>
                                <span class="PageNumber">第{{curPage}}页/共{{allPage}}页</span>
                                <span @click="handleNext" class="PageBtn">下一页</span>
                           </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Menu from './../../common/cmpnt/menu/Menu'
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import DatePicker from './datePicker.vue'//日期
    import { log } from 'util';

    export default {
        name: "ChargeBill",
        components: {
            Menu,
            Loading,
            DatePicker
        },
        data() {
            return {
                ChargeList: [],
                isLoading:true,
                noneDataMsg:'',//无数据
                End: this.getDate(0),
                Start: this.getDate(-90),
                //分页
                allPage: '', //总页数
                curPage: 1, //当前页码
                pageSize: 8, //每页展示数量
                calendar: {
                    show: false,
                    start: '',
                    last: this.getDate(0),
                    begin: this.getDate(-90),
                    end: this.getDate(0),
                    select: (begin, end) => {
                        if (!begin) {
                            this.calendar.show = false;
                            this.calendar.begin = this.Start;
                            this.calendar.end = this.End;
                            return;
                        }
                        this.calendar.begin = begin;
                        this.calendar.end = end;
                        this.Start = begin;
                        this.End = end;
                        this.$nextTick(function () {
                            this.calendar.show = false;
                        });
                    }
                },
            }
        },
        watch:{},
        computed:{},
        mounted() {
            document.title = '充值记录'
            this.getChargeData()
        },
        methods: {
            export2Excel() {
                let that = this
                that.getChargeData(true)
                let param = {
                    Page: 1,
                    PageSize: 9999,
                    End: this.End,
                    Start: this.Start
                }
                that.isLoading = true
                //  发请求
                that.postRequest({
                    //  请求的url   api文件里面写的
                    url:that.Api.getRecharges,
                    params:param
                }).then(res => {
                    if(res.IsSuccess){
                        //  如果成功了
                        
                        that.isLoading = false
                        require.ensure([], () => {
                            const { export_json_to_excel } = require('../../common/excel/Export2Excel'); //这里必须使用绝对路径
                            const tHeader = ['货币类型','充值金额','已使用金额','充值时间']; // 导出的表头名
                            const filterVal = ['Currency','ArriveNum','UsedNum','CreationDate',]; // 导出的表头字段名
                            const list = that.tableExcelData(res.Result);
                            const data = that.formatJson(filterVal, list);
                            export_json_to_excel(tHeader, data, '充值记录');// 导出的表格名称，根据需要自己命名
                        })

                        if(!res.Total){
                            that.noneDataMsg='暂无数据...'
                        }else{
                            that.noneDataMsg=''
                        }
                    }else{
                        //  如果失败了
                        this.error({title:'提示',content:res.Msg||'保存失败'});
                    }
                })

            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            tableExcelData(list){
                var l = [];
                for(let i=0; i<list.length; i++){
                    var lis = {
                        Currency:list[i].Currency,
                        ArriveNum:list[i].ArriveNum,
                        UsedNum:list[i].UsedNum,
                        CreationDate: this.filterDateToYMDline(list[i].CreationDate)
                    };
                    l.push(lis)
                }
                return l
            },
            filterDateToYMDline(date) {
                if (!date) return '';
                var da = new Date(date);
                var year = da.getFullYear();
                var month = da.getMonth() + 1;
                var day = da.getDate();
                if (month < 10) {
                    month = '0' + month
                };
                if (day < 10) {
                    day = '0' + day
                };
                return year + '-' + month + '-' + day;
            },

            handlePrev(){
                if(this.curPage>1){
                    this.curPage--;
                    this.getChargeData()
                }else {
                     this.error({title:'提示',content:'当前为最前页'});
                }
            },


            handleNext(){
                if(this.curPage<this.allPage){
                    this.curPage++;
                    this.getChargeData()
                }else {
                     this.error({title:'提示',content:'当前为最后页'});
                }
            },

            getChargeData (flag) {
                let that = this
                if(flag){
                    this.curPage = 1
                }
                let param = {
                    Page: this.curPage,
                    PageSize: this.pageSize,
                    End: this.End,
                    Start: this.Start
                }
                that.isLoading = true
                //  发请求
                that.postRequest({
                    //  请求的url   api文件里面写的
                    url:that.Api.getRecharges,
                    params:param
                }).then(res => {
                    that.ChargeList = []
                    if(res.IsSuccess){
                        //  如果成功了
                        that.isLoading = false
                        that.ChargeList = res.Result
                        that.allPage = Math.ceil(res.Total/that.pageSize)
                        if(!res.Total){
                            that.curPage = 1
                            that.noneDataMsg='暂无数据...'
                        }else{
                            that.noneDataMsg=''
                        }
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }       
                        })
                    }else{
                        //  如果失败了
                        this.error({title:'提示',content:res.Msg||'保存失败'});
                    }
                });
            }
        }
    }
</script>

<style scoped>
.time {
    overflow: auto;
}

.time>input {
    text-align: center;
    padding: 5px 0;
    border: 1px solid #d1d1d1;
}

.time .timeSearch {
    float: right;
    padding: 10px 30px;
    color: #fff;
    cursor: pointer;
    background-color: #28c667;
}
.time .timeExcel{
    float: right;
    padding: 10px 30px;
    margin-left:20px; 
    background: #f5f5f5;
    color: #333;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/bill/ChargeBill.vue